<template>
  <section>
    <div
      class="chart-box"
      ref="myChart"
      :style="{ height: boxHeight + 'rem' }"
    ></div>
  </section>
</template>

<script>
import * as echarts from "echarts";
export default {
  data() {
    return {};
  },
  props: {
    boxHeight: {
      default: 0,
      type: Number,
    },
  },
  components: {},

  mounted() {
    // this.drawChart();
    window.onresize = function () {
      this.myChart.resize();
    };
  },

  methods: {
    upDateChart(content) {
      this.myChart.setOption({
        series: [{ data: content.data }],
        yAxis: [
          // {
          //   data: (() => {
          //     if (this.graphicalRightData) {
          //       let list = [];
          //       content.yName.map((y, y_index) => {
          //         list.push(y_index + 1);
          //       });
          //       return list;
          //     } else {
          //       return content.yName;
          //     }
          //   })(),
          // },
          {
            data: content.data,
          },
        ],
      });
    },
    drawChart(data) {
      let _data = data;
      // console.log("传过来的data", _data);
      let colorList = ["#0ca4ff","#9b89c7","#f68133","#79aa2b","#db6e6a","#99d9ff"]
      let myChart = echarts.init(this.$refs.myChart);
      let option = {
        color:colorList,
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(0,0,0,0.3)",
          borderWidth: "0",
          textStyle: {
            color: "#fff",
            fontSize: this.$common.setFontSize(0.69),
          },
        },
        legend: {
          show:false,
          top: 15,
          textStyle: {
            color: "#FFF",
            fontSize: this.$common.setFontSize(0.69),
          },
        },
        grid: {
          left: "15%",
          // right: "4%",
          bottom: 30,
          height:"65%"
          // containLabel: true,
        },
        xAxis: {
          type: "value",
          lineStyle: {
            color: "#fff",
          },
          axisLabel: {
            color: "#fff",
            fontSize: this.$common.setFontSize(0.69),
          },
        },
        yAxis: {
          type: "category",
          data: _data.nameArr,
          lineStyle: {
            color: "#fff",
          },
          axisLabel: {
            color: "#fff",
            fontSize: this.$common.setFontSize(0.69),
            formatter: function (params) {
              let val = "";
              if (params.length > 3) {
                val = params.substr(0, 3) + "...";
                return val;
              } else {
                return params;
              }
            },
          },
        },
        series: (() => {
          let arr = [];
          _data.seriesArr.map((obj, o_index) => {
            let item = {
              name: obj.name,
              type: "bar",
              stack: "total",
              barWidth: 10,
              label: {
                show: true,
                color: colorList[o_index],
                formatter: function (params) {
                  if (params.data > 1500) {
                    return params.data;
                  } else {
                    return "";
                  }
                },
                fontSize: this.$common.setFontSize(0.69),
                position:"bottom"
              },
              // emphasis: {
              //   focus: "series",
              // },
              data: obj.data,
            };
            arr.push(item);
          });
          return arr;
        })(),
      };
      myChart.setOption(option);
    },
  },
};
</script>
<style lang='scss' scoped>
.chart-box {
  // height: 400px;
}
</style>